import {sm2} from 'sm-crypto'
export default {
    //加密 SM2
    SM2Encrypt(word, keyStr = '047CCE5A18104BA1475A2029D0F448CF0FEA1AE0A912F1595D87B67CADE1C2FFAE2983B65B7D87BADF299DA377CDE775E91414CDC23AC9AA2362B50C3014025396') {
        return sm2.doEncrypt(word, keyStr, 0)
    },
    //解密 SM2
    SM2Decrypt(word, keyStr = '047CCE5A18104BA1475A2029D0F448CF0FEA1AE0A912F1595D87B67CADE1C2FFAE2983B65B7D87BADF299DA377CDE775E91414CDC23AC9AA2362B50C3014025396') {
      return sm2.doDecrypt(word, keyStr, 0)
    }
  }


// WEBPACK FOOTER //
// ./src/utils/sm2.js